import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatRupiah } from "@/lib/api";
import { Trash2, Minus, Plus } from "lucide-react";

export default function Cart() {
  const { items, update, remove, total } = useCart();

  if (items.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="cart-empty">
        <div className="label-mono text-zinc-500">// 00 ITEMS</div>
        <h1 className="font-display text-4xl font-black uppercase mt-2">Keranjang kosong</h1>
        <p className="text-zinc-600 mt-3">Yuk pilih produk dulu di katalog.</p>
        <Link to="/catalog" className="btn-primary inline-block mt-6">Lihat Katalog</Link>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-10" data-testid="cart-page">
      <div className="label-mono text-zinc-500">// CHECKOUT 01</div>
      <h1 className="font-display text-4xl md:text-5xl font-black uppercase mt-1">Keranjang</h1>

      <div className="mt-8 grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 border border-black bg-white">
          {items.map((item) => (
            <div key={item.product_id} className="grid grid-cols-[80px_1fr_auto] gap-4 p-4 border-b border-black last:border-b-0 items-center" data-testid={`cart-item-${item.product_id}`}>
              <div className="w-20 h-20 overflow-hidden border border-black bg-zinc-100">
                {item.image_url && <img src={item.image_url} alt="" className="w-full h-full object-cover" />}
              </div>
              <div className="min-w-0">
                <div className="badge-status bg-white text-[10px]">{item.type.toUpperCase()}</div>
                <div className="font-display font-bold uppercase mt-1 line-clamp-2">{item.name}</div>
                <div className="font-mono text-sm mt-1">{formatRupiah(item.price)}</div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center border border-black">
                  <button onClick={() => update(item.product_id, item.quantity - 1)} className="p-2 hover:bg-black hover:text-white"><Minus className="w-3 h-3" /></button>
                  <span className="px-3 font-mono font-bold">{item.quantity}</span>
                  <button onClick={() => update(item.product_id, item.quantity + 1)} className="p-2 hover:bg-black hover:text-white"><Plus className="w-3 h-3" /></button>
                </div>
                <button onClick={() => remove(item.product_id)} className="p-2 border border-black hover:bg-[#FF3333] hover:text-white" data-testid={`remove-${item.product_id}`}><Trash2 className="w-3.5 h-3.5" /></button>
              </div>
            </div>
          ))}
        </div>

        <aside className="border border-black bg-white p-6 shadow-brutal h-fit">
          <div className="label-mono text-zinc-500">// SUMMARY</div>
          <h2 className="font-display text-2xl font-black uppercase mt-1">Total</h2>
          <div className="space-y-2 mt-6 font-mono text-sm">
            {items.map((i) => (
              <div key={i.product_id} className="flex justify-between text-zinc-600">
                <span className="truncate pr-2">{i.name} ×{i.quantity}</span>
                <span>{formatRupiah(i.price * i.quantity)}</span>
              </div>
            ))}
          </div>
          <div className="border-t border-black mt-4 pt-4 flex justify-between items-end">
            <span className="label-mono">Total</span>
            <span className="font-mono text-2xl font-black" data-testid="cart-total">{formatRupiah(total)}</span>
          </div>
          <Link to="/checkout" className="btn-primary w-full mt-6 text-center block" data-testid="checkout-btn">Checkout →</Link>
        </aside>
      </div>
    </div>
  );
}

